import Tasks from '../../controllers/tasks';

export default instance => {
  instance.attachEvent('onAfterTaskMove', (id, parent, tindex) => Tasks.onAfterTaskMove(id, parent, tindex));
};
